import { products } from "./data";
import { Link } from "react-router-dom";
import React from "react";
const Products = (props) => {
  const [search, setSearch] = React.useState("");
  let [newProducts, setNewProducts] = React.useState([]);
  const [buttonValue, setButtonValue] = React.useState(false);
  const [viewFunc, setViewFunc] = React.useState({ id: null });
  const handleSearch = (e) => {
    setSearch(e.target.value);
    newProducts = products.filter((a) =>
      a.name.toLowerCase().includes(search.toLowerCase())
    );
    setNewProducts(newProducts);
  };
  return (
    <div>
      <div className="link-search">
        <div>
          <Link className="product-link">Featured Products</Link>
          <Link className="product-link" to="/upcoming">
            Upcoming
          </Link>
        </div>
        <div>
          <input
            type="text"
            placeholder="search for your favorites"
            value={search}
            onChange={handleSearch}
            className="input-field search-field"
          />
        </div>
      </div>
      <div>
        <div className="products">
          {search === ""
            ? products.map((e) => {
                return (
                  <div className="product-card" key={e.id}>
                    <span className="badge">
                      {e.bestSeller && "Best Seller"}
                    </span>
                    <img src={e.img} alt="" />
                    <h3>
                      {e.name} <Link to={`/products/${e.id}`}>more info</Link>
                    </h3>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i
                      className="fa fa-star-half half-star"
                      aria-hidden="true"
                    ></i>
                    <span className="card-items">
                      <Link
                        to="/payments"
                        className="btn btn-buy"
                        onClick={() =>
                          props.setTotal(e.price * 0.8 + e.delivery, e.id)
                        }
                      >
                        Buy
                      </Link>
                      <Link to="/wishlist">
                        <i
                          className="fa fa-light fa-heart"
                          onClick={() => props.handleWishlist(e)}
                        ></i>
                      </Link>
                      <button
                        className="btn btn-add-to-cart"
                        onClick={() => {
                          props.handleCart(e);
                          setButtonValue(true);
                          setViewFunc({ id: e.id });
                        }}
                      >
                        {buttonValue & (e.id === viewFunc.id)
                          ? "Added"
                          : "Add to cart"}
                      </button>
                    </span>
                  </div>
                );
              })
            : newProducts.map((e) => {
                return (
                  <div className="product-card" key={e.id}>
                    <span className="badge">
                      {e.bestSeller && "Best Seller"}
                    </span>
                    <img src={e.img} alt="" />
                    <h3>{e.name}</h3>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i className="fa fa-star gold"></i>
                    <i
                      className="fa fa-star-half half-star"
                      aria-hidden="true"
                    ></i>
                    <span className="price-badge">
                      ${(0.8 * e.price).toFixed(2)}
                    </span>
                    <span className="old-price">${e.price}</span>
                    <span className="card-items">
                      <h4>20% off</h4>
                      <Link
                        to="/payments"
                        className="btn btn-buy"
                        onClick={() =>
                          props.setTotal(e.price * 0.8 + e.delivery, e.id)
                        }
                      >
                        Buy
                      </Link>
                      <button className="btn btn-add-to-cart">
                        Add to cart
                      </button>
                    </span>
                    <span className="delivery">
                      ${e.delivery}
                      <span className="w-700 size-16 m-5p">
                        Delivery to Pakistan
                      </span>
                      <Link to={`/products/${e.id}`}>more info</Link>
                    </span>
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};
export default Products;
